<template>
  <v-card>
    <v-toolbar
      color="primary"
      dark
    >
    <v-tabs v-model="scopeIndex">
         <v-tab >
            Mine
        </v-tab>
        <v-tab >
            Shared
        </v-tab>
    </v-tabs>
      <v-spacer></v-spacer>
      <v-btn icon color="white" dark>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-list>
         <v-list-item v-if="locationScope === 'mine' && noMyLocationGroups">
            There are no locations to display.
        </v-list-item>
        <v-list-item v-if="noSharedLocationGroups && locationScope === 'shared_with_me'">
            There are no shared locations yet.
        </v-list-item>
        <v-list-item-group
          color="primary">
          <v-list-item
            v-for="item in scopedLocationGroups"
            :key="item.id"
            :append-icon="null"
            no-action
            :class="[item.active ? 'elevation-2' : 'elevation-0', 'group-'+item.id]"
          >
          <v-list-item-icon>
            <v-btn icon @click="selectedItem = item.id"

            >

              <v-icon>{{icon(item)}}</v-icon>
            </v-btn>

          </v-list-item-icon>
          <v-list-item-content>
              <div v-if="form !== item.id">
                 <v-hover v-slot="{ hover }">
                <v-list-item-title v-text="item.name"
                :id="item.id"
                :class ="cursorStyle(item, hover)"
                @dblclick="showInput(item)" :title="locationScope==='mine'?'Double-click to edit': ''" />
                </v-hover>
               <v-list-item-subtitle
                v-text="formatDate(new Date(item.created_at))"
                ></v-list-item-subtitle>
              </div>

              <div v-if="form === item.id">
                <EditingForm :item="item" :update="update" color="blue" :xSmall="true" @hideForm="form=''"/>



              </div>
          </v-list-item-content>
            <v-list-item-action class="small"
              v-if="! item.processed_at && form!==item.id"
              style="color: #999;"
              v-text="item.processing_stage? item.processing_stage + '...': 'Queueing...'"
            >
            </v-list-item-action>
            <v-list-item-action v-if="! item.processed_at">
              <v-col>
              <DeleteButton
               :disabled="deleteIsDisabled(item)"
              route="custom_location_group"
              :id="item.id"
              :size="size"
              color="info"
              name="location group"
              @deleted="deleteLocation(item.id)"/>

            </v-col>
            </v-list-item-action>

            <v-list-item-action
              v-else
            >
              <v-row>
                <v-col>
                    <v-tooltip
                    bottom
                    :nudge-top="tooltip.nudgeTop"
                    :nudge-right="tooltip.nudgeRight">
                        <template v-slot:activator="{ on, attrs }">
                <div v-on="on">

                  <v-btn
              color="info"
              icon
              v-bind="attrs"
              v-on="on"
              class="ml-1"
              @click="showInput(item)"
              :disabled="pencilIsDisabled(item)"
            >
              <v-icon>mdi-pencil</v-icon>

            </v-btn>
                </div>
            </template>
            <span>{{isNotMine(item)? `Only owners can edit`: 'Edit'}}</span>
                    </v-tooltip>
              </v-col>
            <v-col>
              <v-btn icon color="info"
              @click="selectedItem = item.id"
              >
                <v-icon>mdi-map-legend</v-icon>
              </v-btn>
                </v-col>
                <v-col>
              <v-btn icon color="info"
                :href="item.download_url"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
              </v-col>
              <v-col>
              <DeleteButton
             :disabled="deleteIsDisabled(item)"
              route="custom_location_group"
              color="info"
              :size="size"
              :id="item.id"
              name="custom location"
              @deleted="deleteLocation(item.id)"/>
            </v-col>

              </v-row>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <location-group-dialog
        :shown="showGroupDialog"
        v-on:close-dialog="showGroupDialog = false"
        :locationGroup="activeItem"
      ></location-group-dialog>
    </v-card-text>
  </v-card>
</template>
<script>
import { formatDate } from '@/utils/format'
import { mapState } from 'vuex'
import LocationGroupDialog from '@/components/LocationGroupDialog.vue'
import DeleteButton from '@/components/DeleteButton.vue'
import EditingForm from '@/components/EditingForm.vue'
import {updateCustomLocation} from '@/utils/custom_locations'
import {get, set} from '@/utils/utils'
export default {
  data() {
    return {
      size: {xSmall: false },
      form: '',
      selectedItem: null,
      showGroupDialog: false,
      scopeIndex: 0,
    }
  },
  components: {
    LocationGroupDialog,
    DeleteButton,
    EditingForm
    },
  computed: {
    scopedLocationGroups(){
       return  this.locationScope =='mine'? this.myLocationGroups: this.sharedLocationGroups
    },
    activeItem(){
        let locationGroups = [];
        this.myLocationGroups.forEach(group => locationGroups.push(group));
        this.sharedLocationGroups.forEach(group => locationGroups.push(group));
        return locationGroups.find(item => this.selectedItem == item.id)
    },
    ...mapState({
      customLocationListRefreshedAt: 'customLocationListRefreshedAt',
      tooltip: 'tooltip',
      myLocationGroups: 'myLocationGroups',
      sharedLocationGroups: 'sharedLocationGroups',
      noMyLocationGroups: 'noMyLocationGroups',
      noSharedLocationGroups: 'noSharedLocationGroups',
      locationScope: 'locationScope'
    })
  },
  mounted() {
    //clicking outside of card corresponding to item with form will remove the form and turn it back to text element
    document.addEventListener('click', event => this.removeForm(event));
    this.$store.dispatch('updateState', ['locationScope', 'mine']);
  },
  methods: {
    isNotMine(item){
        //warning: we'll have to change this once you can navigate to "shared" tab without passing through "mine" first
        //the ternary operator handles vue type error (though technically things work without it)
        return !this.myLocationGroups.find(group => group.id === item.id)? true: false
    },
    hasForm(item){
        return this.form === item.id
    },
    pencilIsDisabled(item){
        return this.isNotMine(item) || this.hasForm(item)
    },
    deleteIsDisabled(item){
        return this.isNotMine(item)
    },
    icon(item){
        //nb: can't do isShared(item) because that presupposes this.sharedLocationGroups is non-empty, which is false if we're in the "mine" tab
        //we don't want checking "share" checkbox to immediately change the icon to shared (since the database isn't updated until the form isn't submitted)
        if(item.is_shared_with_account && item.id!== this.form){
            return 'mdi-folder-account-outline'
        }
        else {
            return item.processed_at? "mdi-folder-marker-outline": 'mdi-folder-clock-outline'
        }
    },
    formatDate(date, localeOptions, hideTime = false){
      return formatDate(date, null, false)
    },
    cursorStyle(item, hover){
        return hover && this.myLocationGroups.find(group=>group.id===item.id)?'text-cursor': 'default-cursor'
    },
    showInput(item){
        if(this.myLocationGroups.find(group=>group.id===item.id)){
            let id = item.id
            //display update form instead of text at selected item:
            this.form = id;
            //wait for input form to display, then mark input text as selected:
            this.$nextTick(()=>{
                let input = document.querySelector(`#form-${id} input`);
                input.focus();
                input.select()})
        }
    },
    update(item){
        this.form = '';
        //database connection actually renaming the custom location
        updateCustomLocation(item.id, item.name, item.is_shared_with_account)
    },
    removeForm(e){
      if(this.form){
      //each card has classname corresponding to item.id
      //this.form stores at most one item id
      //so we're finding the card containing the form
      let parent = document.getElementsByClassName(`group-${this.form}`)[0]

      //toggle form to text if clicking outside of form card:
      if(parent&&!parent.contains(e.target) ){
        this.form = '';

      }
      }
    },
    deleteLocation(id){
        //you can't delete shared locations, so we know myLocationGroups is the one to filter
      let myLocationGroups = this.myLocationGroups.filter(x=>x.id !=id)


      this.$store.dispatch('updateState', ['myLocationGroups', myLocationGroups])
      let locationsToCheck = get('locationsToCheck');

      locationsToCheck = locationsToCheck.filter(x=>x.id!==id)
      set('locationsToCheck', locationsToCheck)



    }
  },
  watch: {
     scopeIndex(newVal){


       if(newVal===0){
            this.$store.dispatch('updateState', ['locationScope', 'mine'])
        }
        else if(newVal===1){
            this.$store.dispatch('updateState', ['locationScope', 'shared_with_me'])
        }


    },
    locationScope(newVal){
          switch(newVal){
            case 'mine':
                this.scopeIndex = 0;
                break;
            case 'shared_with_me':
                this.scopeIndex = 1;
                break;
        }
    },
    showGroupDialog(newVal) {
      if (!newVal) {
        this.selectedItem = null
        let locationGroups = [];
        this.myLocationGroups.forEach(group=> locationGroups.push(group));
        this.sharedLocationGroups.forEach(group=> locationGroups.push(group));
        locationGroups.forEach(g => {
          g.active = false
        });
        if(this.locationScope === 'mine'){
        this.$store.dispatch('updateState', ['myLocationGroups', locationGroups]);}
        else{
         this.$store.dispatch('updateState', ['sharedLocationGroups', locationGroups])
        }
      }
    },
    selectedItem: function(newVal){
      if (this.selectedItem != null) {

        this.showGroupDialog = true
      }
    }

  }
}
</script>

<style scoped>
.text-cursor{
    cursor: text
}
.default-cursor{
    cursor: default !important
}

.small{
    max-width:30%;
}
.v-list-item{
  margin-top: 20px;
  margin-bottom: 20px;
}

.v-messages {
    font-size: 14px !important;
}

.col{
  padding: 0;
}

.v-list-item{
  padding-right:0;
}
.v-list-item__title{
  cursor: text;
}

.row {margin-right: 0 !important}
@media only screen and (max-width: 1270px){

.v-btn{
  font-size:0.6rem;
}
}
</style>
